/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Ingredients_TextInputs */

const en_editor_ingredients_text = /** @type {(inputs: Editor_Ingredients_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingredients, one per line`)
};

const de_editor_ingredients_text = /** @type {(inputs: Editor_Ingredients_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zutaten, eine pro Zeile`)
};

/**
* | output |
* | --- |
* | "Ingredients, one per line" |
*
* @param {Editor_Ingredients_TextInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_ingredients_text = /** @type {((inputs?: Editor_Ingredients_TextInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Ingredients_TextInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_ingredients_text(inputs)
	return en_editor_ingredients_text(inputs)
});